
"use strict";
(function () {

// Detect mobile device (Do not remove!!!)
var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Nokia|Opera Mini/i.test(navigator.userAgent) ? true : false;
if (isMobile) {
    document.body.classList.add("is-mobile");
}


// Page Loader
window.addEventListener("load", function () {
    setTimeout(function () {
        const pageLoader = document.querySelector(".page-loader");
        pageLoader.style.transition = "opacity 0.8s ease";
        pageLoader.style.opacity = "0";

        setTimeout(function () {
            pageLoader.style.display = "none";
        }, 800);

    }, 800);
    gsap.to(".bar", 1.5, {
        delay: 0,
        height: 0,
        stagger: {
            amount: 0.5
        },
        ease: "power4.inOut"
    });
});


// swiper slider
// var logoSlider = document.querySelector('.swiper-logo-slider');
// if(logoSlider) {
//     var swiperOptions = {
//         direction: 'horizontal',
//         loop: true,
//         autoplay: {
//             delay: 5000,
//             disableOnInteraction: false
//         },
//         slidesPerView: 'auto',
//         speed: 6000,
//         grabCursor: true,
//         allowTouchMove: true,
//     };
//     var swiper = new Swiper(".swiper-logo-slider", swiperOptions);
// }

var quotesSlider = document.querySelector('.quotes-slider');
if(quotesSlider) {
    var swiperOptions2 = {
         slidesPerView: 'auto',
        spaceBetween: 20,
        navigation: {
            nextEl: '.swiper-button-next1',
            prevEl: '.swiper-button-prev1',
        }
    };
    var swiper = new Swiper(".quotes-slider", swiperOptions2);
}
var quotesSlider = document.querySelector('.quotes-slider-two');
if(quotesSlider) {
    var swiperOptions2 = {
        slidesPerView: '1',
        navigation: {
            nextEl: '.swiper-button-next1',
            prevEl: '.swiper-button-prev1',
        }
    };
    var swiper = new Swiper(".quotes-slider-two", swiperOptions2);
}


var carousel_main = document.querySelector('.carousel_main');
if(carousel_main) {
    var swiperOptions3 = {
        effect: "coverflow",
        grabCursor: true,
        slidesPerView: 3,
        spaceBetween: 50,
        centeredSlides: true,
        coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 3,
            slideShadows: true
        },
        loop: true,
        // navigation: {
        //     nextEl: '.swiper-button-next2',
        //     prevEl: '.swiper-button-prev2',
        // },
        pagination: {
            el: ".swiper-pagination2",
            clickable: true
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 2
            },
            1560: {
                slidesPerView: 3
            }
        }
    };
    var swiper = new Swiper(".carousel_main", swiperOptions3);
}



// Image parallax
var imageParallax = document.querySelectorAll(".parallax-image");
if (imageParallax.length > 0) {
    imageParallax.forEach(function (element) {
        // Add wrap <div>.
        var parallaxImageWrap = document.createElement("div");
        parallaxImageWrap.classList.add("parallax-image-wrap");

        var parallaxImageInner = document.createElement("div");
        parallaxImageInner.classList.add("parallax-image-inner");

        element.parentNode.insertBefore(parallaxImageWrap, element);
        parallaxImageWrap.appendChild(parallaxImageInner);
        parallaxImageInner.appendChild(element);

        // Add overflow hidden.
        parallaxImageWrap.style.overflow = "hidden";

        var animImageParallax = element;
        var aipWrap = animImageParallax.closest(".parallax-image-wrap");
        var aipInner = aipWrap.querySelector(".parallax-image-inner");

        var tl_ImageParallax = gsap.timeline({
            scrollTrigger: {
                trigger: aipWrap,
                start: "top bottom",
                end: "bottom top",
                scrub: true,
                onEnter: animImgParallaxRefresh
            }
        });
        tl_ImageParallax.to(animImageParallax, { yPercent: 30, ease: "none" });

        function animImgParallaxRefresh() {
            tl_ImageParallax.scrollTrigger.refresh();
        }

        // Zoom in
        var tl_aipZoomIn = gsap.timeline({
            scrollTrigger: {
                trigger: aipWrap,
                start: "top 99%"
            }
        });
        tl_aipZoomIn.from(aipInner, { duration: 1, autoAlpha: 0, scale: 1.2, ease: "power2.out", clearProps: "all" });
    });
}









// Smooth scroll

// const isTouchDevice = 'ontouchstart' in document.documentElement;

// disableScroll();
// if (!isTouchDevice) smoothScroll();

// window.onresize = () => {
//   resizeBodyHeight();
// };

// window.onload = () => {
//   enableScroll();
//   resizeBodyHeight();
// };

// // Functions
// function disableScroll() {
//   document.body.style.overflow = 'hidden';
// }
// function enableScroll() {
//   document.body.style.overflow = '';
// }
// function smoothScroll() {
//   document.querySelector('.viewport').classList.add('SmoothScroll');
//   new SmoothScroll({
//     target: document.querySelector('.smoothscroll-inr'),
//     scrollEase: 0.1,
//     maxOffset: 500,
//   });
// }
// function resizeBodyHeight() {
//   document.body.style.height = document.querySelector('.viewport').scrollHeight + 'px';
// }







// Magic cursor (no effect on small screens!)
if (!document.body.classList.contains("is-mobile")) {
    const cursor = document.querySelector(".cursor");
    const follower = document.querySelector(".follower");
    const cursorScale = document.querySelectorAll(".cursor-scale");
    
    document.addEventListener("pointermove", function (e) {
        positionCircle(e);
    });

    function positionCircle(e) {
        let relX = e.clientX;
        let relY = e.clientY;
        TweenMax.from(cursor, 0.3, { x: relX - 0, y: relY - 0 });
        TweenMax.to(follower, 0.3, { x: relX - 21, y: relY - 21 });
    }
    const cursorPlay = document.querySelectorAll(".cursor-play");
    cursorPlay.forEach((cursorPlay) => {
        cursorPlay.addEventListener("mouseenter", function () {
            document.querySelector(".cursor").classList.add("cursor-play");
            document.querySelector(".cursor-play").classList.remove("cursor-drag");
        });

        cursorPlay.addEventListener("mouseleave", function () {
            document.querySelector(".cursor").classList.remove("cursor-play");
        });
    });
    const cursorDrag = document.querySelectorAll(".swiper-container, .quotes-wrapper");
    cursorDrag.forEach((cursorDrag) => {
        cursorDrag.addEventListener("mouseenter", function () {
            document.querySelector(".cursor").classList.add("cursor-drag");
        });

        cursorDrag.addEventListener("mouseleave", function () {
            document.querySelector(".cursor").classList.remove("cursor-drag");
        });
    });

} else {
    const cursor = document.querySelector(".cursor");
    const follower = document.querySelector(".follower");
    if (cursor) cursor.remove();
    if (follower) follower.remove();
}



if (!document.body.classList.contains("is-mobile")) {

    //PARALLAX ITEM
    // Wrapping elements with the class "parallax-item"
    var parallaxItems = document.querySelectorAll(".parallax-item");
    parallaxItems.forEach(function (item) {
        var itemWrap = document.createElement("div");
        itemWrap.classList.add("parallax-item-wrap");
        item.parentNode.insertBefore(itemWrap, item);
        itemWrap.appendChild(item);
    });

    // Get all the wrapped items
    var itemWraps = document.querySelectorAll(".parallax-item-wrap");

    // The calcValue function
    function calcValue(value, inputMax, inputMin, outputMax, outputMin) {
        var percent = (value - inputMin) / (inputMax - inputMin);
        var output = percent * (outputMax - outputMin) + outputMin;
        return output;
    }

    // Adding event listeners to each wrapped item
    itemWraps.forEach(function (itemWrap) {
        var item = itemWrap.querySelector(".parallax-item");
        itemWrap.addEventListener("mousemove", function (e) {
            var mouseX = e.clientX;
            var mouseY = e.clientY;
            var rect = itemWrap.getBoundingClientRect();
            var offsetX = rect.left + rect.width / 2;
            var offsetY = rect.top + rect.height / 2;
            var deltaX = mouseX - offsetX;
            var deltaY = mouseY - offsetY;
            var percentX = deltaX / (itemWrap.clientWidth / 2);
            var percentY = deltaY / (itemWrap.clientHeight / 2);

            item.style.transform = `
                translateX(${calcValue(percentX, 1, -1, 20, -20)}px) 
                translateY(${calcValue(percentY, 1, -1, 20, -20)}px) 
                rotateX(${calcValue(percentY, 1, -1, 5, -5)}deg) 
                rotateY(${calcValue(percentX, 1, -1, -5, 5)}deg)
            `;
        });

        itemWrap.addEventListener("mouseleave", function () {
            item.style.transform = "translateX(0) translateY(0) rotateX(0) rotateY(0)";
        });
    });
}






//GSAP scrollTrigger
gsap.registerPlugin(ScrollTrigger);

var brandlinkLogo = function() {
    var e = document.querySelectorAll(".swiper-wrapper");
    e && e.length && e.forEach((function(e) {
        ! function(e) {
            var t = e.querySelectorAll(".brand-link_logo"),
                r = 0.5;
            t && t.length && t.forEach((function(t) {
                gsap.set(t, {
                    opacity: 0,
                    y: 20
                }), gsap.to(t, {
                    opacity: 1,
                    y: 0,
                    duration: 1,
                    delay: r,
                    ease: "power1.out",
                    scrollTrigger: {
                        trigger: e,
                        start: "top center+=500"
                    }
                }), r += .1
            }))
        }(e)
    }))
};

window.addEventListener("load", function () {
    brandlinkLogo();
});

let animationRotate = document.querySelectorAll(".animation-rotate");
animationRotate.forEach((animationRotate) => {
    gsap.to(animationRotate, {
        duration: 2,
        rotation: 360,
        ease: "linear",
        repeat: -1
    });
});

let scrollRotate = document.querySelectorAll(".scroll-rotate");
scrollRotate.forEach((scrollRotate) => {
    gsap.to(scrollRotate, {
        scrollTrigger: {
            trigger: scrollRotate,
            scrub: 2
        },
        rotation: 720
    });
});

let scrollMoveRight = document.querySelectorAll(".scroll-move-right");
scrollMoveRight.forEach((scrollMoveRight) => {
    gsap.to(scrollMoveRight, {
        x: 500,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveRight,
            start: "top 30%",
            scrub: 2
        }
    });
});

let scrollMoveLeft = document.querySelectorAll(".scroll-move-left");
scrollMoveLeft.forEach((scrollMoveLeft) => {
    gsap.to(scrollMoveLeft, {
        x: -500,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveLeft,
            start: "top 30%",
            scrub: 2
        }
    });
});

let scrollMoveRightLarge = document.querySelectorAll(".scroll-move-rightlarge");
scrollMoveRightLarge.forEach((scrollMoveRightLarge) => {
    gsap.to(scrollMoveRightLarge, {
        x: 700,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveRightLarge,
            start: "top bottom",
            scrub: 2
        }
    });
});

let scrollMoveLeftLarge = document.querySelectorAll(".scroll-move-leftlarge");
scrollMoveLeftLarge.forEach((scrollMoveLeftLarge) => {
    gsap.to(scrollMoveLeftLarge, {
        x: -700,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveLeftLarge,
            start: "top bottom",
            scrub: 2
        }
    });
});


let scrollMoveRight2 = document.querySelectorAll(".scroll-move-right2");
scrollMoveRight2.forEach((scrollMoveRight2) => {
    gsap.to(scrollMoveRight2, {
        x: 800,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveRight2,
            start: "top 100%",
            scrub: 2
        }
    });
});

let scrollMoveLeft2 = document.querySelectorAll(".scroll-move-left2");
scrollMoveLeft2.forEach((scrollMoveLeft2) => {
    gsap.to(scrollMoveLeft2, {
        x: -400,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveLeft2,
            start: "top 100%",
            scrub: 2
        }
    });
});

let scrollMoveUp = document.querySelectorAll(".scroll-move-up");
scrollMoveUp.forEach((scrollMoveUp) => {
    gsap.to(scrollMoveUp, {
        y: -400,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveUp,
            start: "top 20%",
            scrub: 2
        }
    });
});



let scrollMoveUpLarge = document.querySelectorAll(".scroll-move-uplarge");
scrollMoveUpLarge.forEach((scrollMoveUpLarge) => {
    gsap.to(scrollMoveUpLarge, {
        y: -800,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveUpLarge,
            start: "top 20%",
            scrub: 2
        }
    });
});

let scrollMoveDownLarge = document.querySelectorAll(".scroll-move-downlarge");
scrollMoveDownLarge.forEach((scrollMoveDownLarge) => {
    gsap.to(scrollMoveDownLarge, {
        y: 1000,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveDownLarge,
            start: "top 20%",
            scrub: 2
        }
    });
});



let growUp = document.querySelectorAll(".grow-up");
growUp.forEach((growUp) => {
    gsap.fromTo(
        growUp,
        {
            autoAlpha: 0.5,
            scale: 0.7
        },
        {
            autoAlpha: 1,
            duration: 2,
            scale: 1,
            scrollTrigger: {
                trigger: growUp,
                start: "top 90%"
            },
            stagger: 0.2
        }
    );
});

let scrollZoomIn = document.querySelectorAll(".scroll-zoom-in");
scrollZoomIn.forEach((scrollZoomIn) => {
    gsap.to(scrollZoomIn, {
        scrollTrigger: {
            trigger: scrollZoomIn,
            start: "top 10%",
            scrub: 2
        },
        scale: 1.5
    });
});

let scrollZoomIn2 = document.querySelectorAll(".scroll-zoom-in-2");
scrollZoomIn2.forEach((scrollZoomIn2) => {
    gsap.to(scrollZoomIn2, {
        scrollTrigger: {
            trigger: scrollZoomIn2,
            start: "top 90%",
            scrub: 2
        },
        scale: 1
    });
});

let scrollZoomOut = document.querySelectorAll(".scroll-zoom-out");
scrollZoomOut.forEach((scrollZoomOut) => {
    gsap.to(scrollZoomOut, {
        scrollTrigger: {
            trigger: scrollZoomOut,
            start: "top 15%",
            scrub: 2
        },
        scale: 0.8
    });
});

let revealContainers = document.querySelectorAll(".reveal-img");
revealContainers.forEach((revealContainers) => {
    let image = revealContainers.querySelector("img");
    let tl4 = gsap.timeline({
        scrollTrigger: {
            trigger: revealContainers,
            toggleActions: "restart none none reset"
        }
    });

    tl4.set(revealContainers, { autoAlpha: 1 });
    tl4.from(revealContainers, 1.5, {
        xPercent: -100,
        ease: Power2.out
    });
    tl4.from(image, 1.5, {
        xPercent: 100,
        scale: 1.3,
        delay: -1.5,
        ease: Power2.out
    });
});


//TEXT-UP
// if (window.innerWidth > 500) {
    var textUpElements = document.querySelectorAll(".text-up");
    textUpElements.forEach(function (element) {
        var revealTextCover = document.createElement("div");
        revealTextCover.classList.add("reveal-text-cover");
        
        var revealText = document.createElement("div");
        revealText.classList.add("reveal-text");
        
        revealTextCover.appendChild(revealText);
        element.parentNode.insertBefore(revealTextCover, element);
        revealText.appendChild(element);
    });
// }


const revealTexts = document.querySelectorAll(".reveal-text");
revealTexts.forEach((revealText) => {
    gsap.set(revealText, { y: 120, opacity: 0 });
    gsap.to(revealText, {
        duration: 1,
        y: 0,
        opacity: 1,
        ease: Power3.easeOut,
        scrollTrigger: {
            trigger: revealText,
            start: "top 100%",
            end: "top 0%",
            toggleActions: "play none none reverse"
        }
    });
});


//FADEIN-UP
const fadeInUp = document.querySelectorAll(".fadeInUp");
fadeInUp.forEach((fadeInUp) => {
    gsap.fromTo(
        fadeInUp,
        {
            opacity: 0,
            scale: 0.8,
            y: 150
        },
        {
            opacity: 1,
            duration: 1.5,
            scale: 1,
            y: 0
        }
    );
});

let scrollMoveUp2 = document.querySelectorAll(".scroll-move-up-2");
scrollMoveUp2.forEach((scrollMoveUp2) => {
    gsap.to(scrollMoveUp2, {
        y: -40,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveUp2,
            start: "top 70%",
            scrub: 2
        }
    });
});

let scrollMoveUp3 = document.querySelectorAll(".scroll-move-up-3");
scrollMoveUp3.forEach((scrollMoveUp3) => {
    gsap.to(scrollMoveUp3, {
        y: -80,
        duration: 2,
        scrollTrigger: {
            trigger: scrollMoveUp3,
            start: "top 70%",
            scrub: 2
        }
    });
});

let scrollMoveUp4 = document.querySelectorAll(".scroll-move-up-4");
scrollMoveUp4.forEach((scrollMoveUp4) => {
    gsap.to(scrollMoveUp4, {
        y: -70,
        duration: 2,
        scrollTrigger: {
            trigger: scrollMoveUp4,
            start: "top 70%",
            scrub: 2
        }
    });
});


  const mediaQuery = window.matchMedia('(max-width: 991px)')
if (mediaQuery.matches) {

  let scrollMoveUp4 = document.querySelectorAll(".scroll-move-up-4");
  scrollMoveUp4.forEach((scrollMoveUp4) => {
    gsap.to(scrollMoveUp4, {
        y: -40,
        duration: 2,
        scrollTrigger: {
            trigger: scrollMoveUp4,
            start: "top 70%",
            scrub: 2
        }
    });
  });

}

//FILLTER BUTTON

let btnTags = document.querySelectorAll(".btn-tags.btn-filter");
btnTags.forEach((btnTags) => {
    gsap.from(btnTags, {
        duration: 2,
        scale: 0.8,
        opacity: 0,
        delay: 0,
        stagger: 0.2,
        ease: "elastic",
        force3D: true,
        scrollTrigger: {
            trigger: btnTags,
            start: "top 80%"
        }
    });
});

//CountUp
const countItem = document.querySelectorAll(".count");
countItem.forEach((countItem) => {
    gsap.from(countItem, {
        textContent: 0,
        duration: 4,
        ease: "power1.in",
        snap: { textContent: 1 },
        stagger: {
            onUpdate: function () {
                this.targets()[0].innerHTML = numberWithCommas(Math.ceil(this.targets()[0].textContent));
            }
        },
        scrollTrigger: {
            trigger: countItem,
            start: "top 90%",
            end: "top 5%"
        }
    });
});
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}




})();

const obj = document.querySelector(".enable-swaying-cards");
if(obj){
(function () {
    window.onload = () => {
		const time = 10000;
		function animStart() {
			if (obj.classList.contains("active") == false) {
				obj.classList.add("active");
              const body = document.body;
              body.style.overflow = "auto";
				setTimeout(() => {
					animEnd();
				}, time);
			}
		}
        
		function animEnd() {
			obj.classList.remove("active");
			obj.offsetWidth;
		}
		document.addEventListener("scroll", function () {
			// scroll or scrollend
			animStart();
		});
		window.addEventListener("resize", animStart);
		animStart();
	};
})();

}


function showformPopup() {  
    document.getElementById("formpopup").classList.add('show');
    document.querySelector("html").classList.add('overflow-hidden');
}
function closeformPopup() {
    document.getElementById("formpopup").classList.remove('show');
    document.querySelector("html").classList.remove('overflow-hidden');
}


function showwhitelablepricingPopup() {  
    document.getElementById("whitelablepopup").classList.add('show');
    document.querySelector("html").classList.add('overflow-hidden');
}
function closewhitelablepricingPopup() {
    document.getElementById("whitelablepopup").classList.remove('show');
    document.querySelector("html").classList.remove('overflow-hidden');
}

function mainPopup() {  
    document.getElementById("mainpopup").classList.add('show');
    document.querySelector("html").classList.add('overflow-hidden');
}
function closemainPopup() {
    document.getElementById("mainpopup").classList.remove('show');
    document.querySelector("html").classList.remove('overflow-hidden');
}



// common popup
function showwcommonpopuppricingPopup() {  
    document.getElementById("commonpopup").classList.add('show');
    document.querySelector("html").classList.add('overflow-hidden');
}
function closecommonpricingPopup() {
    document.getElementById("commonpopup").classList.remove('show');
    document.querySelector("html").classList.remove('overflow-hidden');
}


function showwaffiliatepopuppricingPopup() {  
    document.getElementById("affiliatepopup").classList.add('show');
    document.querySelector("html").classList.add('overflow-hidden');
}
function closeaffiliatepricingPopup() {
    document.getElementById("affiliatepopup").classList.remove('show');
    document.querySelector("html").classList.remove('overflow-hidden');
}


// Price table tabs
const plan_tab_li = document.querySelectorAll(".plan_tab");
const pricing_data = document.querySelectorAll(".pricing-box h3");

plan_tab_li.forEach((li) => {
  li.addEventListener("click", (e) => {
    plan_tab_li.forEach((tab) => {
      tab.classList.remove("active");
    });
    e.currentTarget.classList.add("active");

    const clickedClassName = e.currentTarget.id;

    pricing_data.forEach((h3) => {
      h3.classList.remove("active");
    });
    pricing_data.forEach((h3) => {
      const h3Class = h3.getAttribute("class");
      if (h3Class == clickedClassName) {
        h3.classList.add("active");
      }
    });
  });
});

setTimeout(() => {
   var video = document.getElementById('myVideo');
    if(video){
     video.addEventListener('click', function() {
        if (video.muted) {
          video.muted = false; 
        } else {
          video.muted = true; 
        }
      });
    }
}, "2000");







gsap.utils.toArray("[data-bg-color]").forEach((section, i) => {
  if (section.getAttribute("data-bg-color") !== null) {
    var colorAttr = section.getAttribute("data-bg-color");

    gsap.to(".article-template", {
      backgroundColor:
        colorAttr === "dark"
          ? gsap.getProperty("html", "--dark")
          : gsap.getProperty("html", "--light"),
      color:
        colorAttr === "dark"
          ? gsap.getProperty("html", "--light")
          : gsap.getProperty("html", "--dark"),
      immediateRender: false,
      scrollTrigger: {
        trigger: section,
        scrub: true,
        start: "top bottom",
        end: "+=100%"
      }
    });
  }
});





const filter_item_main = document.querySelector('.reveal-text-cover');
const filter_items = filter_item_main.querySelectorAll('.filter-item[data-category]');
filter_items.forEach(item=>{
  item.addEventListener('click',()=>{
    filter_items.forEach(active_item=>{
      active_item.classList.remove('filter-item--active');
    })
    item.classList.add('filter-item--active');
  })
  filter_items[0].classList.add('filter-item--active');
});





let process1 = document.querySelector('.client-say-wrapper');
if ((typeof(process1) != 'undefined' && process1 != null)) {
  let sections = gsap.utils.toArray('.single-card');
  gsap.to(sections, {
    xPercent: -88 * (sections.length - 1),
    ease: "none",
    scrollTrigger: {
      start: "center center",
      pin: true,
      scrub: true,
      // end: "+=300",
      trigger: process1,
      markers: false,
      // pin: true,
      snap: 1 / (sections.length - 1),
      end: () => "+=" + document.querySelector(".client-say-wrapper").offsetWidth
    },
  });
}









let rotateLeftimage = document.querySelectorAll(".rotate-image-left");
rotateLeftimage.forEach((rotateLeftimage) => {
    gsap.to(rotateLeftimage, {
        x: -50,
        rotation: -35,
        duration: 2,
        scrollTrigger: {
            trigger: rotateLeftimage,
            scrub: 2
        }
    });
});

let rotateRightimage = document.querySelectorAll(".rotate-image-right");
rotateRightimage.forEach((rotateRightimage) => {
    gsap.to(rotateRightimage, {
        x: 50,
        rotation: 35,
        duration: 2,
        scrollTrigger: {
            trigger: rotateRightimage,
            scrub: 2
        }
    });
});



// var swiper = new Swiper('.swiper-initialize', {
//   slidesPerView: 5,
//   spaceBetween: 20,
//   breakpoints: {
//     1920: {
//       slidesPerView: 5
//     },
//     992: {
//       slidesPerView: 3
//     },
//     320: {
//       slidesPerView: 2
//     }
//   },
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev'
//   }
// });

var quotesSlider = document.querySelector('.aud_quotes_slider');
if(quotesSlider) {
    var swiperOptions4 = {
         slidesPerView: 2,
        spaceBetween: 24,
        navigation: {
            nextEl: '.swiper-button-next1',
            prevEl: '.swiper-button-prev1',
        },
      breakpoints: {
            600: {
                slidesPerView: 1, // Ensure 1 slide on tablets/phones
                spaceBetween: 10, // Optional smaller space on smaller devices
            }
        }
    };
    var swiper = new Swiper(".aud_quotes_slider", swiperOptions4);
}


document.addEventListener("DOMContentLoaded", function() {
  const readMoreBtn = document.querySelectorAll('.read-more-btn');

  readMoreBtn.forEach(function(button) {
    const content = button.previousElementSibling; // The paragraph element
    const fullText = content.innerHTML.trim(); // Get the full text of the paragraph
    const maxLength = 200; // Define the character limit for truncation

    // Check if text needs truncation
    if (fullText.length > maxLength) {
      content.dataset.fullText = fullText; // Store full text in a data attribute
      content.classList.add('truncated'); // Apply truncation class for CSS ellipsis

    } else {
      button.style.display = 'none'; // Hide the read more button if text is short
    }

    button.addEventListener('click', function() {
      if (!content.classList.contains('expanded')) {
        content.classList.remove('truncated'); // Remove truncation, let full text show
        content.classList.add('expanded');
        this.innerHTML = 'Read less';
      } else {
        content.classList.remove('expanded'); // Collapse text back to truncated version
        content.classList.add('truncated');
        this.innerHTML = 'Read more';
      }
    });
  });
});






